import { Component } from '@angular/core';

@Component({
  selector: 'maintenance-page',
  standalone: false,
  templateUrl: './maintenance.page.html',
  styleUrls: ['./maintenance.page.scss'],
})
export class MaintenancePage {}
